import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'livraisonphotos'
})
export class LivraisonphotosPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
